const words = ["Custom design", "Hand-built", "Mobile ready", "Fast loading", "Monthly maintenance", "Modern & slick"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {words.map((w) => (
      <span key={w} className="flex items-center font-display text-4xl font-light italic tracking-tight text-slate-200 sm:text-6xl">
        <span className="px-8">{w}</span>
        <span className="h-3 w-3 rounded-full bg-blue-600" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="marquee" className="overflow-hidden border-y border-white/5 bg-[#0A1128] py-10">
    <div className="marquee-track flex w-max">
      <Row /><Row />
    </div>
  </section>
);
